import { Box } from '@mui/material';

export const ColorCellWrapper = ({ color, error }: { color: string | null; error?: boolean }) => {
  return (
    <Box
      sx={(theme) => ({
        position: 'absolute',
        left: 0,
        top: 0,
        zIndex: 0,
        bottom: 0,
        ...(error
          ? {
              backgroundColor: theme.palette.error.superLight,
              border: `1px solid ${theme.palette.error.main}`,
              width: '100%',
            }
          : {}),
        ...(!error && color
          ? { borderRadius: 0.5, bgcolor: color, m: 0.25, width: 'calc(100% - 4px)' }
          : {}),
      })}
    />
  );
};
